/**
 * SizilPro — PageHeader
 * Reusable page heading bar: title, optional subtitle, optional action buttons.
 */

import type { ReactNode } from "react";

interface Props {
  title:    string;
  subtitle?: string;
  actions?:  ReactNode;
}

export function PageHeader({ title, subtitle, actions }: Props) {
  return (
    <div className="flex items-start justify-between mb-8">
      <div>
        <h1 className="text-xl font-bold text-white">{title}</h1>
        {subtitle && (
          <p className="text-sm text-white/40 mt-1">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 shrink-0 ml-4">
          {actions}
        </div>
      )}
    </div>
  );
}
